export const IMG_URL = 'https://xgzh-fe.oss-cn-hangzhou.aliyuncs.com/xg-web-operate/'
export const SUCCESS_CODE = 0
export let Gtoken = {
  aaa: ''
}
